// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2993":"2f2ad2ed8c548c54","4466":"ea5f321880e1d004","6184":"9a7b4d16ba667cf6","6677":"0287f63ccd263534"}[chunkId] + ".css";
};